import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './data.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CorteProveedorService extends BaseService {
  constructor(httpClient: HttpClient, authService: AuthService) {
    super('v1/cortes-proveedor', httpClient, authService);
  }

  obtenerProductosVendidos(proveedorId: number, filtros?: any): Observable<any> {
    let params: any = {
      soloPendientes: filtros?.soloPendientes !== false ? '1' : '0'
    };
    
    if (filtros?.fechaInicio) {
      params.fechaInicio = filtros.fechaInicio;
    }
    if (filtros?.fechaFin) {
      params.fechaFin = filtros.fechaFin;
    }
    if (filtros?.nombre) {
      params.nombre = filtros.nombre;
    }
    if (filtros?.etiqueta) {
      params.etiqueta = filtros.etiqueta;
    }

    return this.get(`proveedor/${proveedorId}/productos-vendidos`, params);
  }

  buscarProductosVendidos(filtros: any): Observable<any> {
    return this.post(filtros, 'productos-vendidos/buscar');
  }

  crearCorteConProductos(corte: any): Observable<any> {
    return this.post(corte, '');
  }

  pagarCorteCompleto(corteId: number, pago: any): Observable<any> {
    return this.put(pago, `${corteId}/pagar`);
  }

  pagarProductosEspecificos(corteId: number, pago: any): Observable<any> {
    return this.put(pago, `${corteId}/pagar-productos`);
  }

  obtenerCortes(proveedorId?: number): Observable<any> {
    const params: any = {};
    if (proveedorId) {
      params.proveedorId = proveedorId.toString();
    }
    return this.get('', params);
  }

  buscarCortes(filtros: any): Observable<any> {
    return this.post(filtros, 'buscar');
  }

  obtenerCortePorId(corteId: number): Observable<any> {
    return this.get(`${corteId}`);
  }
}
